import { Injectable } from '@angular/core';
import { IOrder } from 'src/app/shared/domain/order.entity';
import { IRequestId, IRequestString } from 'src/app/shared/domain/id.entity';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable()
export class OrdersService {

  private readonly baseUrl = `${environment.apiBaseUrl}orders`;

  constructor(private httpClient: HttpClient) {
  }

  get(body: IRequestId): Observable<IOrder> {
    return this.httpClient.post<IOrder>(this.baseUrl, body);
  }

  getPendingDataForMonth(body: IRequestString): Observable<PendingDataForMonth[]> {
    return this.httpClient.post<PendingDataForMonth[]>(this.baseUrl + '/data/pending', body);
  }
}

export interface PendingDataForMonth {
  numberOfDaysLeft?: number;
  daysInMonth?: number;
  approvedCount?: number;
  pendingCount?: number;
  approvedRebate?: number;
  pendingRebate?: number;
  monthRebateQuota?: number;
  fundsRemaining?: number;
  isFundsTrackingEligible?: boolean;
}
